import React, { useState, useEffect } from "react";
import axios from "axios";
import { BaseUrl, excelDownloadUrl } from "../../container/BaseUrl/BaseUrl";
import { Button, Pagination, Skeleton, Stack, Typography } from "@mui/material";
import { FunnelSimple } from "@phosphor-icons/react";
import { RiErrorWarningLine } from "react-icons/ri";
import { DownloadSimple } from "@phosphor-icons/react";
import moment from "moment";
import { toast } from "react-toastify";
import FileSaver from "file-saver";
import {
  FormControls,
  MenuItems,
  Selects,
} from "../../components/Styled-component/TablePagination";
const AgentStatusReport = () => {
  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
  const [showfilter, setshowfilter] = useState("sidebar_filter");
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [agentstatus, setagentstatus] = useState([]);
  const [agentlist, setAgentlist] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [agentid, setAgentid] = useState("");
  const [multiPageVal, setMultiPageVal] = React.useState(10);
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [loadingAgentreports, setLoadingAgentreports] = useState(false);
  useEffect(() => {
    agentListdropdown();
  }, []);
  useEffect(() => {
    agentReportData();
  }, [page, multiPageVal]);
  const agentListdropdown = async () => {
    await axios
      .post(
        BaseUrl + "/users/listagentList",
        {
          user_id: basedOnRole.user_id,
          type: "AllAgent",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setAgentlist(res.data.data);
      })
      .catch((err) => {
        setShow(true);
      });
  };
  const agentReportData = async () => {
    const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/agentstatusreport",
        {
          from_date: fromdate ? fromdate : defaultValue,
          to_date: todate ? todate : defaultValue,
          offset: page == 1 ? 0 : (page - 1) * multiPageVal,
          limit: multiPageVal,
          agent_id: agentid ? agentid : "",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setagentstatus(res.data.Data);
          setPagination(res.data.count);
          setLoadingAgentreports(false);
        } else {
          setagentstatus([]);
          setLoadingAgentreports(false);
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((error) => {});
  };
  const DownloadAgentStatusReports = async () => {
    const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + "/users/agentstatusreportexcel",
        {
          from_date: fromdate ? fromdate : defaultValue,
          to_date: todate ? todate : defaultValue,
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
          agent_id: agentid ? agentid : "",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status == true) {
          let file = excelDownloadUrl + res.data.message;
          FileSaver.saveAs(file);
        } else {
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((error) => {});
  };
  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleChangeSetPage = async (event) => {
    setMultiPageVal(event.target.value);
    setPage(1);
  };

  return (
    <div className="sessiontable" style={{ overflow: "hidden" }}>
      <header className="header_role ">
        <div className="conatiner-fluid">
          <nav
            className="navbar"
            style={{ paddingTop: "0px", paddingBottom: "0px" }}
          >
            <div className="container-fluid p-0">
              <div className="hed_left d-flex">
                <h1 style={{ fontWeight: "bold", fontSize: "14px" }}>
                  Agent Status Report
                </h1>
              </div>

              <div className="hed_right d-flex ">
                <Stack direction={"row"} spacing={1} alignItems={"center"}>
                  <Button
                    size="small"
                    variant="contained"
                    endIcon={<DownloadSimple size={18} weight="bold" />}
                    onClick={DownloadAgentStatusReports}
                  >
                    Download
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    endIcon={<FunnelSimple size={18} weight="bold" />}
                    onClick={() => {
                      setshowfilter("sidebar_filter active-r");
                    }}
                  >
                    Filter
                  </Button>
                </Stack>
              </div>
            </div>
          </nav>
        </div>
      </header>

      <div className="container-fluid" style={{ paddingLeft: "1px" }}>
        <div className="container-fluid p-2">
          <div className="card fixed-table-card vh-69">
            <div
              className="card-body agentContactbody"
              style={{ height: "70dvh" }}
            >
              <div className="table-responsive vhm-68">
                <table className="table table-sm  table-hover align-middle table-fixeded">
                  <thead>
                    <tr>
                      <th scope="col">Agent Name</th>
                      <th scope="col">Agent Status Report</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingAgentreports ? (
                      [...Array(2)].map((_, rowIndex) => (
                        <tr key={rowIndex}>
                          {[...Array(10)].map((_, colIndex) => (
                            <td key={colIndex}>
                              <Skeleton variant="text" width={90} height={30} />
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : agentstatus.length > 0 ? (
                      agentstatus.map((rowData) => {
                        console.log("rowData", rowData);
                        return (
                          <tr key={rowData._id}>
                            <td>{rowData.users.username}</td>
                            <td>
                              <table className="table table-sm  table-hover align-middle table-fixeded">
                                <thead>
                                  <tr>
                                    <th scope="col">Date</th>
                                    <th scope="col">Agent Status</th>
                                    <th scope="col">Start Time</th>
                                    <th scope="col">End Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {rowData.documents.map((item) => {
                                    return (
                                      <tr key={item._id}>
                                        <td>
                                          {item.created_at
                                            ? moment(item.created_at).format(
                                                "ll"
                                              )
                                            : "--"}
                                        </td>
                                        <td>
                                          {item.value ? item.value : "--"}
                                        </td>
                                        <td>
                                          {item.created_at
                                            ? moment(item.created_at).format(
                                                "HH:mm:ss"
                                              )
                                            : "--"}
                                        </td>
                                        <td>
                                          {item.ended_at
                                            ? moment(item.ended_at).format(
                                                "HH:mm:ss"
                                              )
                                            : "--:--:--"}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8">
                          <div
                            className="text-muted"
                            style={{
                              flexDirection: "column",
                              marginTop: "20%",
                              display: "flex",
                              position: "absolute",
                              left: "45%",
                              bottom: "40%",
                            }}
                          >
                            <span className="mx-auto">
                              <RiErrorWarningLine size={30} />
                            </span>
                            <span className="mx-auto">
                              <h5
                                className="text-muted mt-2"
                                style={{ fontFamily: "poppins" }}
                              >
                                No Data Found
                              </h5>
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="card-footer rounded-0 d-flex justify-content-between">
            <div>
              {`Showing ${Math.min(
                (page - 1) * multiPageVal + 1,
                isNaN(pagination) ? 0 : pagination
              )} to ${Math.min(
                page * multiPageVal,
                isNaN(pagination) ? 0 : pagination
              )} of ${isNaN(pagination) ? 0 : pagination} entries`}
            </div>
            <div className="d-flex">
              <Typography
                className="mt-1"
                sx={{ textTransform: "capitalize", fontSize: "12px" }}
              >
                Set page
              </Typography>
              <FormControls
                className="ms-1"
                size="small"
                sx={{ textTransform: "capitalize", fontSize: "12px" }}
              >
                <Selects
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  label="multiPageVal"
                  value={multiPageVal}
                  onChange={handleChangeSetPage}
                >
                  <MenuItems value={10}>10</MenuItems>
                  <MenuItems value={20}>20</MenuItems>
                  <MenuItems value={50}>50</MenuItems>
                  <MenuItems value={100}>100</MenuItems>
                  <MenuItems value={500}>500</MenuItems>
                </Selects>
              </FormControls>
            </div>
            <Pagination
              count={Math.ceil(pagination / multiPageVal)}
              page={page}
              color="primary"
              size="small"
              style={{ float: "right" }}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <nav className={showfilter} style={{ top: "0px" }}>
        <div className="filter col-md-12 shadow p-4 ">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="mb-0">Filters</p>
            <div className="dismiss ">
              <span
                className="material-symbols-outlined"
                onClick={() => {
                  setshowfilter("sidebar_filter");
                }}
              >
                cancel
              </span>
            </div>
          </div>

          <div className="filter_form">
            <form className=" fillter_form2 " style={{ height: "75vh" }}>
              <div className="custom_div">
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="fromdate" className="form-label">
                    From
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={fromdate}
                    onChange={(e) => setFromdate(e.target.value)}
                    max={defaultValue}
                  />
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="todate" className="form-label">
                    To Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={todate}
                    onChange={(e) => setTodate(e.target.value)}
                    max={defaultValue}
                  />
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="Select" className="form-label">
                    Agent
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setAgentid(e.target.value)}
                  >
                    <option value="">Select Agent </option>
                    {agentlist.length > 0 ? (
                      agentlist.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.username}
                          </option>
                        );
                      })
                    ) : (
                      <option>No Agent Found</option>
                    )}
                  </select>
                </div>
              </div>
            </form>
            <div className="filter_submit">
              <div className="d-flex">
                <div className="col-md-12 ps-2">
                  <button
                    type="button"
                    id="agent_filter_Submit"
                    className="btn btn-primary w-100 "
                    onClick={() => {
                      agentReportData();
                      setshowfilter("sidebar_filter");
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default AgentStatusReport;
